/**
 * Converts a base64 encoded string to a Blob
 * @param base64String - The base64 encoded string
 * @param mimeType - The MIME type of the file (e.g., 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
 * @returns A Blob object that can be used for file downloads
 */
const base64ToBlob = (base64String: string, mimeType: string): Blob => {
  const byteCharacters = atob(base64String);
  const byteNumbers = new Array(byteCharacters.length)
    .fill(0)
    .map((_, i) => byteCharacters.charCodeAt(i));
  const byteArray = new Uint8Array(byteNumbers);
  return new Blob([byteArray], { type: mimeType });
};

export default base64ToBlob;
